<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-switch
        v-model="menuSetting.isValidFloorPlan"
        label="間取り"
        class="v-input--reverse"
      />
    </v-flex>
    <v-flex v-if="menuSetting.isValidFloorPlan" xs10 offset-xs1>
      <v-layout row wrap>
        <v-checkbox
          v-for="floorPlan in floorPlans"
          :key="floorPlan.name"
          v-model="floorPlan.value"
          :label="floorPlan.name"
          class="horizontal-list"
        />
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'CampaignModalPageMansionFloorPlan',
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      floorPlans: [
        { name: '1R', value: false },
        { name: '1K', value: false },
        { name: '1DK', value: false },
        { name: '1LDK', value: false },
        { name: '2K', value: false },
        { name: '2DK', value: false },
        { name: '2LDK', value: false },
        { name: '3K', value: false },
        { name: '3DK', value: false },
        { name: '3LDK', value: false },
        { name: '4K', value: false },
        { name: '4DK', value: false },
        { name: '4LDK', value: false },
        { name: '5LDK以上', value: false },
      ],
    }
  },
  watch: {
    floorPlans: {
      handler(value) {
        value = value
          .filter(floorPlan => floorPlan.value === true)
          .map(floorPlan => floorPlan.name)
        this.menuSetting.floorPlan.floorPlans = value
      },
      deep: true,
    },
  },
  created() {
    this.floorPlans.map(floorPlan => {
      if (this.menuSetting.floorPlan.floorPlans.indexOf(floorPlan.name) > -1) {
        floorPlan.value = true
      }
    })
  },
  methods: {
    validate() {
      if (!this.menuSetting.isValidFloorPlan) {
        return true
      }
      return this.menuSetting.floorPlan.floorPlans.length !== 0
    },
  },
}
</script>

<style scoped lang="scss">
.horizontal-list {
  display: inline-block;
}

.v-input--reverse {
  ::v-deep .v-input__slot {
    flex-direction: row-reverse;
    .v-input--selection-controls__input {
      margin-left: 8px;
    }
  }
}
</style>
